<div class="d--f jc--c ai--c h--100 w--100">
  <my-rep-empty-screen [options]="emptyScreenOptions"></my-rep-empty-screen>
</div>
